import React, { Fragment, useEffect, useRef, useState } from "react"

import Sub from "~layout/sub"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"

import "./css/gameSlay.css"
import psleMascotAnimation from "./psle_mascot.json"

const crumbs = [
    { text: "Mobile Practice Apps", to: "/slay" },
]

const storeBadges = {
    appStore: require('~images/gameslay/ielts/icon/app store@2x.png'),
    googlePlay: require('~images/gameslay/ielts/icon/play store@2x.png'),
}

const gameSlayPage = () => {

    let content = (
        <Fragment>
            <div className="game-content-wrapper_">
                <section className="game-section_ psle-section_">
                    <div className="game-introduction_ psle-introduction_">
                        <div className="psle-left_">
                            <div className="game-logo_ psle-logo_">
                                <img src={require('~images/gameslay/psle/psle-logo.png').default} alt="PSLE Slay Logo" title="PSLE Slay" />
                            </div>
                            <div className="game-available-location_ psle-available-location_">
                                <div className="game-app_ psle-app_">
                                    <PSLEMascot fallbackImage={require('~images/gameslay/psle/monster@2x.png').default} />
                                    <div className="game-app-launch_">
                                        <p><strong>PSLE Slay</strong> is available on</p>
                                        <ul>
                                            <li>
                                                <a href="https://apps.apple.com/us/app/psle-%E5%8D%8E%E6%96%87-slay/id6769615970" target="_blank" rel="noopener noreferrer" title="Download PSLE Slay on the App Store">
                                                    <img src={storeBadges.appStore.default} alt="App Store Badge" title="Download on the App Store" />
                                                </a>
                                                {/* <img src={storeBadges.appStore.default} alt="App Store Badge" title="Download on the App Store" /> */}
                                            </li>
                                            <li>
                                                <a href="https://play.google.com/store/apps/details?id=com.commontown.atn.dp.pslecn" target="_blank" rel="noopener noreferrer" title="Get PSLE Slay on Google Play">
                                                    <img src={storeBadges.googlePlay.default} alt="Google Play Badge" title="Get it on Google Play" />
                                                </a>
                                                {/* <img src={storeBadges.googlePlay.default} alt="Google Play Badge" title="Get it on Google Play" /> */}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="game-description_ psle-description_">
                            <div className="game-title_">PSLE Slay</div>
                            <div className="game-summary_">
                                <p>Ace your PSLE Chinese one step at a time. Simply spend 20 minutes a day answering questions, reviewing clear and easy-to-understand explanations, and building your skills progressively. As you move through the levels, you&apos;ll strengthen your mastery of Chinese with greater confidence.</p>
                                <p>With more than 3,000 questions, PSLE Chinese Slay is designed for Primary 4 to Primary 6 students preparing for the PSLE Chinese examination. The app focuses on Sections 1 and 2 of the paper, helping you strengthen your pinyin, vocabulary, and grammar skills through adaptive practice.</p>
                                <p>Powered by the Rasch algorithm, the app personalises learning based on your ability level, ensuring that practice remains appropriately challenging and motivating. Regular use helps you learn faster, build exam confidence, and stay ahead academically.</p>
                                <p>Developed by CommonTown, a trusted education technology company with over 20 years of experience, the app combines research-backed learning methods with engaging practice activities.</p>
                                <p className="game-note_"><em>Note: The PSLE (Primary School Leaving Examination) is a national examination in Singapore administered by the Singapore Examinations and Assessment Board (SEAB). This app is independently developed and is not affiliated with SEAB.</em></p>
                            </div>
                        </div>
                        <div className="game-demo_ psle-demo_">
                            <PSLECarousel />
                        </div>
                    </div>
                </section>

                <section className="game-section_ ielts-section_">
                    <div className="game-introduction_ ielts-introduction_">
                        <div className="game-logo_">
                            <img src={require('~images/gameslay/ielts/logo/IELTSSlay.png').default} alt="IELTS Slay Logo" title="IELTS Slay" />
                        </div>
                        <div className="game-available-location_">
                            <div className="game-app_">
                                <div className="game-app-launch_">
                                  <p><strong>IELTS<sup>&reg;</sup> Slay</strong> is available on</p>
                                  <ul>
                                      <li>
                                          <a href="https://apps.apple.com/us/app/ielts-slay/id6743145873" className="ielts-app-anchor_" target="_blank" rel="noopener noreferrer" title="Download on the App Store">
                                              <img src={storeBadges.appStore.default} alt="App Store Badge" title="Download on the App Store" />
                                          </a>
                                      </li>
                                      <li>
                                          <a href="https://play.google.com/store/apps/details?id=com.commontown.atn.dp" className="ielts-app-anchor_" target="_blank" rel="noopener noreferrer" title="Get it on Google Play">
                                              <img src={storeBadges.googlePlay.default} alt="Google Play Badge" title="Get it on Google Play" />
                                          </a>
                                      </li>
                                  </ul>
                                </div>
                                <div className="game-app-social_">
                                  <ul>
                                    <li>Follow us on</li>
                                    <li>
                                      <a href="https://www.facebook.com/ieltsSlay/" target="_blank" rel="noopener noreferrer" title="Follow IELTS Slay on Facebook!">
                                           <img src={require('~images/gameslay/ielts/icon/fb@3x.png').default} alt="Facebook Badge" title="Follow us on Facebook!" />
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                            </div>
                        </div>
                        <div className="game-description_">
                            <div className="game-title_">IELTS<sup>&reg;</sup> Slay</div>
                            <div className="game-summary_">
                                <p>
                                    IELTS<sup>&reg;</sup> Slay is an adaptive IELTS vocabulary and grammar practice app. It delivers quiz questions according to the student's proficiency in English using the highly effective Rasch algorithm. Using it regularly improves the student's IELTS level in a very short time.
                                </p>
                                <p>
                                    It has been proudly developed by CommonTown which has more than 20 years of experience in educational technology research and products.
                                </p>
                                <p className="game-note_"><em>Note: IELTS<sup>&reg;</sup> is a registered trade-mark of Cambridge Assessment English, the British Council and IDP Education. This app is not affiliated with or endorsed by the IELTS Partners.</em></p>
                            </div>
                        </div>
                         <div className="game-demo_">
                            <Carousel />
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    )

    return (
        <Sub title="Mobile Practice Apps" seo_name="Mobile Practice Apps" content={content} />
    )
}

const Carousel = () => (
  <div className="game-carousel_">
    <CarouselBlock />
  </div>
)

const PSLECarousel = () => (
  <div className="psle-carousel_">
    <PSLECarouselBlock />
  </div>
)

const PSLEMascot = ({ fallbackImage }) => {
  const mascotRef = useRef(null)
  const [isLottieReady, setIsLottieReady] = useState(false)

  useEffect(() => {
    let animation
    let isMounted = true

    import("lottie-web").then((lottieModule) => {
      const lottie = lottieModule.default || lottieModule

      if (!isMounted || !mascotRef.current || !lottie) {
        return
      }

      try {
        animation = lottie.loadAnimation({
          container: mascotRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: psleMascotAnimation,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid meet",
          },
        })
        animation.addEventListener("DOMLoaded", () => {
          if (isMounted) {
            setIsLottieReady(true)
          }
        })
      } catch (error) {
        return
      }
    }).catch(() => {})

    return () => {
      isMounted = false
      if (animation) {
        animation.destroy()
      }
    }
  }, [])

  return (
    <div className="psle-mascot_" aria-hidden="true">
      {!isLottieReady && <img className="psle-mascot-fallback_" src={fallbackImage} alt="" />}
      <div className="psle-mascot-lottie_" ref={mascotRef} />
    </div>
  )
}

const PSLECarouselBlock = () => {
  let settings = {
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
           arrows: true,
          dots: false,
        },
      },
    ],
  }

  return (
    <Slider {...settings}>
      {psleSlides.map((slide) => {
        let { title, image } = slide;

        return (
          <div className="psle-block_" key={title}>
            <img src={`${image.default}`} alt={`${title}`} title={`${title}`}/>
          </div>
        )
      })}
    </Slider>
  )
}

const CarouselBlock = () => {
  let settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
           arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: false,
        },
      },
    ],
  }

  return (
    <Slider {...settings}>
      {slides.map((slide) => {
        let { title, image } = slide;

        return (
          <div className="game-block" key={title}>
            <img src={`${image.default}`} alt={`${title}`} title={`${title}`}/>
          </div>
        )
      })}
    </Slider>
  )
}

const psleSlides = [
  {
    image: require("~images/gameslay/psle/psle-slay-screen-1.png"),
    title: "PSLE Slay Level Selection",
  },
  {
    image: require("~images/gameslay/psle/psle-slay-screen-2.png"),
    title: "PSLE Slay Level Selection",
  },
  {
    image: require("~images/gameslay/psle/psle-slay-screen-3.png"),
    title: "PSLE Slay Level Selection",
  },
  {
    image: require("~images/gameslay/psle/psle-slay-screen-4.png"),
    title: "PSLE Slay Level Selection",
  },
  {
    image: require("~images/gameslay/psle/psle-slay-screen-5.png"),
    title: "PSLE Slay Level Selection",
  },
  {
    image: require("~images/gameslay/psle/psle-slay-screen-6.png"),
    title: "PSLE Slay Level Selection",
  },
  
]

const slides = [
  {
    image: require("~images/gameslay/ielts/appscreenshots_2.png"),
    title: "Dashboard",
    description:"",
  },
  {
    image: require("~images/gameslay/ielts/appscreenshots_1.png"),
    title: "Scoreboard",
    description:"",
  },
  {
    image: require("~images/gameslay/ielts/appscreenshots_3.png"),
    title: "Question Bank",
    description:"",
  },
  {
    image: require("~images/gameslay/ielts/appscreenshots_4.png"),
    title: "Leaderboard",
    description:"",
  },
]


export default gameSlayPage
